import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { IUser } from 'types/user';

interface IGlobal {
	user: IUser | null;
	/** False until the first `GET /api/auth/me` on this page load has finished. */
	sessionReady: boolean;
}

const initialState: IGlobal = {
	user: null,
	sessionReady: false,
};

export const globalSlice = createSlice({
	name: 'global',
	initialState,
	reducers: {
		setUser: (state, action: PayloadAction<IUser>) => {
			state.user = action.payload;
		},
		clearUser: (state) => {
			state.user = null;
		},
		setSessionReady: (state) => {
			state.sessionReady = true;
		},
	},
});

export const { setUser, clearUser, setSessionReady } = globalSlice.actions;

export default globalSlice.reducer;
